     document.addEventListener('DOMContentLoaded', function () {
         const showSizeGuideButton = document.getElementById('sizeGuideToggle');
    const closeSizeGuideButton = document.querySelector('.close-button');
    const sizeGuideModal = document.querySelector('.size-guide-modal');

    if (showSizeGuideButton && closeSizeGuideButton && sizeGuideModal) {
        showSizeGuideButton.addEventListener('click', function () {
            sizeGuideModal.classList.remove('tw-hidden');
        });

    closeSizeGuideButton.addEventListener('click', function () {
        sizeGuideModal.classList.add('tw-hidden');
    });
  }
});
 